import React from 'react';
import PropTypes from 'prop-types';

const ThreeDot = ((props) => {
    return (
        <svg width="16" height="5" viewBox="0 0 16 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.65797 2.53289C9.65797 3.44991 8.9171 4.19078 8.00008 4.19078C7.08306 4.19078 6.3422 3.44991 6.3422 2.53289C6.3422 1.61587 7.08306 0.875 8.00008 0.875C8.9171 0.875 9.65797 1.61587 9.65797 2.53289ZM14.2171 0.875C13.3001 0.875 12.5592 1.61587 12.5592 2.53289C12.5592 3.44991 13.3001 4.19078 14.2171 4.19078C15.1341 4.19078 15.875 3.44991 15.875 2.53289C15.875 1.61587 15.1341 0.875 14.2171 0.875ZM0.125 2.53301C0.125 1.61599 0.865869 0.875122 1.78289 0.875122C2.69991 0.875122 3.44078 1.61599 3.44078 2.53301C3.44078 3.45003 2.69991 4.1909 1.78289 4.1909C0.865869 4.1909 0.125 3.45003 0.125 2.53301Z" fill="#262aff"/>
        </svg>
         
    )
})

ThreeDot.props = {
    onClick: PropTypes.func,
}

ThreeDot.defaultProps = {
    onClick: () => { },
}

export default ThreeDot;